import React, { useEffect, useState } from "react";
import TopBar from "../../components/TopBar"; // <-- IMPORT

export default function AllegatiGestionePage({ onLogout }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch("/api/allegati/list.php", { credentials: "include" });
                const j = await r.json();
                if (j.ok) setItems(j.items || []);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    if (loading) {
        return (
            <>
                <TopBar title="Allegati di Gestione" onLogout={onLogout} />
                <div className="p-4">Caricamento...</div>
            </>
        );
    }

    return (
        <>
            {/* 🔥 TOPBAR */}
            <TopBar
                title="Allegati di Gestione"
                onLogout={onLogout}
            />

            <div className="min-h-screen bg-slate-100 p-4 md:p-6">
                <div className="mb-4">
                    <h1 className="text-2xl font-bold">Allegati di Gestione</h1>
                    <p className="text-slate-600 text-sm">
                        Documenti HACCP stampabili con carta intestata
                    </p>
                </div>

                <div className="bg-white rounded-xl shadow overflow-hidden">
                    {items.map((it) => (
                        <div
                            key={it.template_key}
                            className="flex items-center justify-between gap-3 px-4 py-3 border-b hover:bg-slate-50"
                        >
                            <div>
                                <div className="font-medium">
                                    {it.codice} — {it.titolo}
                                </div>
                                <div className="text-sm text-gray-500">
                                    PDF con carta intestata
                                </div>
                            </div>

                            <a
                                className="px-3 py-2 rounded-lg bg-black text-white text-sm hover:bg-gray-800"
                                href={it.pdf_url}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Apri PDF
                            </a>
                        </div>
                    ))}

                    {items.length === 0 && (
                        <div className="p-4 text-sm text-slate-500">
                            Nessun allegato disponibile
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}